import { useSearchParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { useDash } from "./ctx";
import Billing from "./Billing";
import Plans from "./Plans";
import AIUsage from "./AIUsage";

// One money console: what you EARN (revenue/margin), what you SELL (plans & add-ons),
// and what it COSTS to run (AI usage + caps) — previously three separate nav tabs.
const TABS = [
  ["revenue", "Revenue & Margin"],
  ["plans", "Plans & Add-ons"],
  ["usage", "AI Usage & Caps"],
];

export default function BillingHub() {
  const { actualRole } = useDash();
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "revenue";
  // A manager who lands here from a bookmark or an email link used to be bounced to the
  // Communities screen with a message about community access, which explains nothing.
  if (actualRole !== "super_admin") {
    return (
      <div className="bg-white rounded-2xl border border-sand-200 p-10 text-center max-w-md mx-auto flex flex-col items-center gap-3"
        data-testid="billing-no-access">
        <Lock className="h-8 w-8 text-sand-300" />
        <p className="font-heading font-bold">Billing lives with Redline</p>
        <p className="text-sm text-muted-foreground">
          Revenue, plans and AI spend are handled by Redline, not by community staff. If you need an
          invoice, a plan change or a copy of your add-ons, ask Redline and we'll send it over.
        </p>
        <div className="flex flex-wrap gap-2 justify-center pt-1">
          <a data-testid="billing-back-dashboard" href="/dashboard"
            className="rounded-full bg-ink text-white text-sm font-semibold px-4 py-2 hover:bg-ink-700">
            Back to your dashboard
          </a>
          <a data-testid="billing-ask-redline" href="/dashboard/help"
            className="rounded-full border border-sand-200 text-sm font-semibold px-4 py-2 hover:border-ink">
            Ask about billing
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <div className="inline-flex flex-wrap rounded-full bg-sand-100 border border-sand-200 p-1" data-testid="billing-hub-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`billing-tab-${k}`} onClick={() => setSp({ tab: k })}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-ink text-white shadow-sm" : "text-ink/60 hover:text-ink"}`}>
            {l}
          </button>
        ))}
      </div>
      {tab === "plans" ? <Plans /> : tab === "usage" ? <AIUsage /> : <Billing />}
    </div>
  );
}
